import { render, staticRenderFns } from "./DeviceEdit.vue?vue&type=template&id=58522d5b&scoped=true"
import script from "./DeviceEdit.vue?vue&type=script&lang=ts"
export * from "./DeviceEdit.vue?vue&type=script&lang=ts"
import style0 from "./DeviceEdit.vue?vue&type=style&index=0&id=58522d5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58522d5b",
  null
  
)

export default component.exports